export default "__VITE_ASSET__DXJEW_Jz__"